export default __webpack_public_path__ + "static/media/hp3.8a5a0bf7.webp";